// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.text-editor {
  width: 100%;
  display: flex;
  height: 1.0625rem;
}
.text-editor-toolbar {
  width: 13%;
  height: 1.0625rem;
  border-radius: 0.03125rem;
  display: grid;
  align-items: end;
  background: #fff;
}
.text-editor-toolbar-icons {
  width: 100%;
  height: 0.8125rem;
  padding-bottom: 0.0625rem;
  display: grid;
  justify-content: center;
  align-items: center;
  border-radius: 0.03125rem 0.03125rem 0 0;
}
.text-editor-toolbar-icons .anticon {
  font-weight: bold;
  font-size: 0.1125rem;
  cursor: not-allowed;
  color: #8c8c8c;
}
.text-editor-toolbar-icons .anticon:hover {
  transform: scale(1.2);
}
.text-editor-toolbar .send {
  width: 100%;
  height: 0.25rem;
  padding: 0;
  border-radius: 0.0625rem;
  background: var(--var-prismer-chatbot);
  box-shadow: none;
}
.text-editor-toolbar .send .anticon {
  font-size: 0.125rem;
  color: #fff;
}
.text-editor-toolbar .send .anticon:hover {
  transform: rotate(-35deg) scale(1.2);
}
.text-editor-toolbar .send .anticon-send {
  margin: -0.025rem -0.0125rem 0 0;
}
.text-editor-toolbar .send .anticon-send {
  transform: rotate(-35deg) scale(1);
}
.text-editor-toolbar .ant-btn-variant-solid:not(:disabled):not(.ant-btn-disabled):hover {
  background: var(--var-prismer-chatbot);
}
.text-editor-container {
  width: 100%;
  border-radius: 0.03125rem;
  padding: 0.0625rem;
  height: 90%;
  position: relative;
  overflow: scroll;
  font-size: 0.0875rem;
  color: var(--var-prismer-chatbot);
}
.text-editor-container::-webkit-scrollbar {
  width: 0;
  height: 0;
}
.text-editor-container:empty:before {
  content: attr(data-placeholder);
  color: var(--var-prismer-chatbot);
  position: absolute;
  pointer-events: none;
  font-size: 0.0875rem;
}
.text-editor-container:focus {
  outline: none;
  border-color: var(--var-prismer-chatbot);
  border-width: 0.0125rem;
  box-shadow: 0.0125rem 0.025rem 0.05rem 0.0125rem rgba(152, 182, 177, 0.3);
}
.text-editor-container .insert-box {
  position: relative;
  display: inline-block;
}
.text-editor-container .insert-box .delete-button {
  position: absolute;
  right: 0.025rem;
  top: 0.0125rem;
  cursor: pointer;
}
.text-editor-container .insert-box-code {
  display: block;
}
.text-editor-container a {
  color: var(--var-prismer-chatbot);
  font-style: italic;
  text-decoration: underline;
}
.text-editor-area {
  width: calc(87% - 0.0625rem);
  height: 100%;
  margin-right: 0.0625rem;
}
.text-editor-area .tips {
  font-size: 0.0375rem;
  color: var(--var-prismer-chatbot);
  padding-left: 0.03125rem;
  margin-top: -0.03125rem;
}
.text-editor-area-main {
  width: 100%;
  height: 100%;
}
.text-editor-empty {
  border: 0.00625rem solid rgba(249, 156, 150, 0.3) !important;
  box-shadow: 0.00625rem 0.00625rem 0.03125rem 0.00625rem rgba(249, 156, 150, 0.1) !important;
  animation: shakeAnimation 300ms ease-in-out 2;
}
.text-editor-area-text {
  position: relative;
  width: 100%;
  height: 100%;
  background: #fff;
  border-radius: 0.05rem;
}
.text-editor .change-model-select {
  display: flex;
  align-items: center;
  position: absolute;
  bottom: 0;
  padding-left: 0.03125rem;
}
.text-editor .change-model-select-arrow {
  display: flex;
  align-items: center;
  margin-right: 0.01875rem;
}
.text-editor .change-model-select-arrow.open {
  transform: rotate(180deg);
}
.text-editor .change-model-select .anticon {
  font-size: 0.05rem;
  color: rgba(152, 182, 177, 0.8);
}
.text-editor .change-model-select .ant-select-selector {
  width: 100%;
  border: none;
  background: none;
  font-size: 0.0625rem;
  padding: 0;
  height: 0.125rem;
}
.text-editor .change-model-select .ant-select-selector .ant-select-selection-item {
  color: var(--var-prismer-chatbot);
}
.text-editor .change-model-select .ant-select-dropdown {
  width: 0.8125rem !important;
  padding: 0.025rem;
}
.text-editor .change-model-select .ant-select-dropdown .ant-select-item {
  padding: 0 0.03125rem;
  min-height: auto;
  font-size: 0.05rem;
  font-family: Roboto;
}
.text-editor .change-model-select .ant-select-dropdown .ant-select-item-option-selected:not(.ant-select-item-option-disabled) {
  background: rgba(152, 182, 177, 0.2);
  border-radius: 0.025rem;
  font-weight: 500;
}
.text-editor .change-model-select .ant-select-dropdown .ant-select-item-option-active:not(.ant-select-item-option-disabled) {
  border-radius: 0.025rem;
}
.text-editor .change-model-select .ant-select-single {
  height: 0.125rem;
}
.text-editor .change-model-select .ant-select-focused.ant-select-outlined:not(.ant-select-disabled):not(.ant-select-customize-input):not(.ant-pagination-size-changer) .ant-select-selector {
  box-shadow: none;
}
@keyframes shakeAnimation {
  0% {
    transform: translateX(0);
  }
  25% {
    transform: translateX(-0.03125rem);
  }
  50% {
    transform: translateX(0.03125rem);
  }
  75% {
    transform: translateX(-0.03125rem);
  }
  100% {
    transform: translateX(0);
  }
}
.text-editor .image-block {
  max-width: 1.25rem;
  max-height: 1.875rem;
  display: block;
  margin: 0.0625rem 0;
}
.text-editor .code-block {
  position: relative;
  margin: 0.0625rem 0;
}
.text-editor .code-block pre {
  background-color: #282c34;
  border-radius: 0.025rem;
  padding: 0.125rem 0.0625rem 0.0625rem 0.0625rem;
  overflow-x: auto;
}
.text-editor .code-block pre::-webkit-scrollbar {
  height: 0.025rem;
  margin-right: 0.0625rem;
}
.text-editor .code-block pre::-webkit-scrollbar-track {
  background-color: var(--var-prismer-color5);
}
.text-editor .code-block pre::-webkit-scrollbar-thumb {
  border-radius: 0.01875rem;
  background-color: #b2b2b2;
}
.text-editor .code-block code {
  font-size: 0.0875rem;
}
.text-editor .ant-popover {
  font-family: Roboto;
  width: 85%;
  margin-right: 0.09375rem;
}
.text-editor .ant-popover .ant-popover-arrow {
  opacity: 0;
}
.text-editor .ant-popover .ant-popover-title {
  font-size: 0.0875rem;
}
.text-editor .ant-popover .ant-input {
  font-size: 0.0875rem;
  height: 0.5rem;
}
.text-editor .ant-popover .ant-input-outlined:focus {
  border-color: var(--var-prismer-chatbot);
  box-shadow: 0.0125rem 0.025rem 0.05rem 0.0125rem rgba(152, 182, 177, 0.3);
}
.text-editor .ant-popover .ant-btn {
  font-size: 0.0875rem;
  box-shadow: none;
}
.text-editor .ant-popover .ant-btn-variant-solid,
.text-editor .ant-popover .ant-btn-variant-solid:not(:disabled):not(.ant-btn-disabled):hover {
  background: var(--var-prismer-chatbot);
}
.text-editor .ant-popover .ant-btn-variant-outlined:not(:disabled):not(.ant-btn-disabled):hover,
.text-editor .ant-popover .ant-btn-variant-dashed:not(:disabled):not(.ant-btn-disabled):hover {
  color: var(--var-prismer-chatbot);
  border-color: var(--var-prismer-chatbot);
}
.text-editor .ant-popover .ant-input-outlined:hover {
  border-color: var(--var-prismer-chatbot);
}`, "",{"version":3,"sources":["webpack://./src/pages/home/component/textEditor/index.scss"],"names":[],"mappings":"AAAA;EACE,WAAA;EACA,aAAA;EACA,iBAAA;AACF;AAAE;EACE,UAAA;EACA,iBAAA;EACA,yBAAA;EACA,aAAA;EACA,gBAAA;EACA,gBAAA;AAEJ;AADI;EACE,WAAA;EACA,iBAAA;EACA,yBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,wCAAA;AAGN;AAFM;EACE,iBAAA;EACA,oBAAA;EAGA,mBAAA;EACA,cAAA;AAER;AADQ;EACE,qBAAA;AAGV;AACI;EACE,WAAA;EACA,eAAA;EACA,UAAA;EACA,wBAAA;EACA,sCAAA;EACA,gBAAA;AACN;AAAM;EACE,mBAAA;EACA,WAAA;AAER;AADQ;EACE,oCAAA;AAGV;AAAM;EACE,gCAAA;AAER;AAAM;EACE,kCAAA;AAER;AACI;EACE,sCAAA;AACN;AAEE;EACE,WAAA;EACA,yBAAA;EACA,kBAAA;EACA,WAAA;EACA,kBAAA;EACA,gBAAA;EACA,oBAAA;EACA,iCAAA;AAAJ;AACI;EACE,QAAA;EACA,SAAA;AACN;AACI;EACE,+BAAA;EACA,iCAAA;EACA,kBAAA;EACA,oBAAA;EACA,oBAAA;AACN;AACI;EACE,aAAA;EACA,wCAAA;EACA,uBAAA;EACA,yEAAA;AACN;AACI;EACE,kBAAA;EACA,qBAAA;AACN;AAAM;EACE,kBAAA;EACA,eAAA;EACA,cAAA;EACA,eAAA;AAER;AACI;EACE,cAAA;AACN;AACI;EACE,iCAAA;EACA,kBAAA;EACA,0BAAA;AACN;AAEE;EACE,4BAAA;EACA,YAAA;EACA,uBAAA;AAAJ;AACI;EACE,oBAAA;EACA,iCAAA;EACA,wBAAA;EACA,uBAAA;AACN;AACI;EACE,WAAA;EACA,YAAA;AACN;AAEE;EACE,4DAAA;EACA,2FAAA;EACA,6CAAA;AAAJ;AAEE;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;EACA,sBAAA;AAAJ;AAEE;EACE,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,SAAA;EACA,wBAAA;AAAJ;AACI;EACE,aAAA;EACA,mBAAA;EACA,wBAAA;AACN;AAAM;EACE,yBAAA;AAER;AACI;EACE,kBAAA;EACA,+BAAA;AACN;AACI;EACE,WAAA;EACA,YAAA;EACA,gBAAA;EACA,oBAAA;EACA,UAAA;EACA,gBAAA;AACN;AAAM;EACE,iCAAA;AAER;AACI;EACE,2BAAA;EACA,iBAAA;AACN;AAAM;EACE,qBAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;AAER;AAAM;EACE,oCAAA;EACA,uBAAA;EACA,gBAAA;AAER;AAAM;EACE,uBAAA;AAER;AACI;EACE,gBAAA;AACN;AACI;EAIE,gBAAA;AAFN;AAKE;EACE;IACE,wBAAA;EAHJ;EAKE;IACE,kCAAA;EAHJ;EAKE;IACE,iCAAA;EAHJ;EAKE;IACE,kCAAA;EAHJ;EAKE;IACE,wBAAA;EAHJ;AACF;AAKE;EACE,kBAAA;EACA,oBAAA;EACA,cAAA;EACA,mBAAA;AAHJ;AAKE;EACE,kBAAA;EACA,mBAAA;AAHJ;AAII;EACE,yBAAA;EACA,uBAAA;EACA,+CAAA;EACA,gBAAA;AAFN;AAGM;EACE,gBAAA;EACA,uBAAA;AADR;AAGM;EACE,2CAAA;AADR;AAGM;EACE,yBAAA;EACA,yBAAA;AADR;AAII;EACE,oBAAA;AAFN;AAKE;EACE,mBAAA;EACA,UAAA;EACA,wBAAA;AAHJ;AAII;EACE,UAAA;AAFN;AAII;EACE,oBAAA;AAFN;AAII;EACE,oBAAA;EACA,cAAA;AAFN;AAII;EACE,wCAAA;EACA,yEAAA;AAFN;AAII;EACE,oBAAA;EACA,gBAAA;AAFN;AAII;;EAEE,sCAAA;AAFN;AAII;;EAEE,iCAAA;EACA,wCAAA;AAFN;AAII;EACE,wCAAA;AAFN","sourcesContent":[".text-editor {\n  width: 100%;\n  display: flex;\n  height: 170px;\n  &-toolbar {\n    width: 13%;\n    height: 170px;\n    border-radius: 5px;\n    display: grid;\n    align-items: end;\n    background: #fff;\n    &-icons {\n      width: 100%;\n      height: 130px;\n      padding-bottom: 10px;\n      display: grid;\n      justify-content: center;\n      align-items: center;\n      border-radius: 5px 5px 0 0;\n      .anticon {\n        font-weight: bold;\n        font-size: 18px;\n        // cursor: pointer;\n        // color: #5c7671;\n        cursor: not-allowed;\n        color: #8c8c8c;\n        &:hover {\n          transform: scale(1.2);\n        }\n      }\n    }\n    .send {\n      width: 100%;\n      height: 40px;\n      padding: 0;\n      border-radius: 10px;\n      background: var(--var-prismer-chatbot);\n      box-shadow: none;\n      .anticon {\n        font-size: 20px;\n        color: #fff;\n        &:hover {\n          transform: rotate(-35deg) scale(1.2);\n        }\n      }\n      .anticon-send {\n        margin: -4px -2px 0 0;\n      }\n      .anticon-send {\n        transform: rotate(-35deg) scale(1);\n      }\n    }\n    .ant-btn-variant-solid:not(:disabled):not(.ant-btn-disabled):hover {\n      background: var(--var-prismer-chatbot);\n    }\n  }\n  &-container {\n    width: 100%;\n    border-radius: 5px;\n    padding: 10px;\n    height: 90%;\n    position: relative;\n    overflow: scroll;\n    font-size: 14px;\n    color: var(--var-prismer-chatbot);\n    &::-webkit-scrollbar {\n      width: 0;\n      height: 0;\n    }\n    &:empty:before {\n      content: attr(data-placeholder);\n      color: var(--var-prismer-chatbot);\n      position: absolute;\n      pointer-events: none;\n      font-size: 14px;\n    }\n    &:focus {\n      outline: none;\n      border-color: var(--var-prismer-chatbot);\n      border-width: 2px;\n      box-shadow: 2px 4px 8px 2px rgba(152, 182, 177, 0.3);\n    }\n    .insert-box {\n      position: relative;\n      display: inline-block;\n      .delete-button {\n        position: absolute;\n        right: 4px;\n        top: 2px;\n        cursor: pointer;\n      }\n    }\n    .insert-box-code {\n      display: block;\n    }\n    a {\n      color: var(--var-prismer-chatbot);\n      font-style: italic;\n      text-decoration: underline;\n    }\n  }\n  &-area {\n    width: calc(87% - 10px);\n    height: 100%;\n    margin-right: 10px;\n    .tips {\n      font-size: 6px;\n      color: var(--var-prismer-chatbot);\n      padding-left: 5px;\n      margin-top: -5px;\n    }\n    &-main {\n      width: 100%;\n      height: 100%;\n    }\n  }\n  &-empty {\n    border: 1px solid rgb(249, 156, 150, 0.3) !important;\n    box-shadow: 1px 1px 5px 1px rgb(249, 156, 150, 0.1) !important;\n    animation: shakeAnimation 300ms ease-in-out 2;\n  }\n  &-area-text {\n    position: relative;\n    width: 100%;\n    height: 100%;\n    background: #fff;\n    border-radius: 8px;\n  }\n  .change-model-select {\n    display: flex;\n    align-items: center;\n    position: absolute;\n    bottom: 0;\n    padding-left: 5px;\n    &-arrow {\n      display: flex;\n      align-items: center;\n      margin-right: 3px;\n      &.open {\n        transform: rotate(180deg);\n      }\n    }\n    .anticon {\n      font-size: 8px;\n      color: rgba(152, 182, 177, 0.8);\n    }\n    .ant-select-selector {\n      width: 100%;\n      border: none;\n      background: none;\n      font-size: 10px;\n      padding: 0;\n      height: 20px;\n      .ant-select-selection-item {\n        color: var(--var-prismer-chatbot);\n      }\n    }\n    .ant-select-dropdown {\n      width: 130px !important;\n      padding: 4px;\n      .ant-select-item {\n        padding: 0 5px;\n        min-height: auto;\n        font-size: 8px;\n        font-family: Roboto;\n      }\n      .ant-select-item-option-selected:not(.ant-select-item-option-disabled) {\n        background: rgba(152, 182, 177, 0.2);\n        border-radius: 4px;\n        font-weight: 500;\n      }\n      .ant-select-item-option-active:not(.ant-select-item-option-disabled) {\n        border-radius: 4px;\n      }\n    }\n    .ant-select-single {\n      height: 20px;\n    }\n    .ant-select-focused.ant-select-outlined:not(.ant-select-disabled):not(\n        .ant-select-customize-input\n      ):not(.ant-pagination-size-changer)\n      .ant-select-selector {\n      box-shadow: none;\n    }\n  }\n  @keyframes shakeAnimation {\n    0% {\n      transform: translateX(0);\n    }\n    25% {\n      transform: translateX(-5px);\n    }\n    50% {\n      transform: translateX(5px);\n    }\n    75% {\n      transform: translateX(-5px);\n    }\n    100% {\n      transform: translateX(0);\n    }\n  }\n  .image-block {\n    max-width: 200px;\n    max-height: 300px;\n    display: block;\n    margin: 10px 0;\n  }\n  .code-block {\n    position: relative;\n    margin: 10px 0;\n    pre {\n      background-color: #282c34;\n      border-radius: 4px;\n      padding: 20px 10px 10px 10px;\n      overflow-x: auto;\n      &::-webkit-scrollbar {\n        height: 4px;\n        margin-right: 10px;\n      }\n      &::-webkit-scrollbar-track {\n        background-color: var(--var-prismer-color5);\n      }\n      &::-webkit-scrollbar-thumb {\n        border-radius: 3px;\n        background-color: #b2b2b2;\n      }\n    }\n    code {\n      font-size: 14px;\n    }\n  }\n  .ant-popover {\n    font-family: Roboto;\n    width: 85%;\n    margin-right: 15px;\n    .ant-popover-arrow {\n      opacity: 0;\n    }\n    .ant-popover-title {\n      font-size: 14px;\n    }\n    .ant-input {\n      font-size: 14px;\n      height: 80px;\n    }\n    .ant-input-outlined:focus {\n      border-color: var(--var-prismer-chatbot);\n      box-shadow: 2px 4px 8px 2px rgba(152, 182, 177, 0.3);\n    }\n    .ant-btn {\n      font-size: 14px;\n      box-shadow: none;\n    }\n    .ant-btn-variant-solid,\n    .ant-btn-variant-solid:not(:disabled):not(.ant-btn-disabled):hover {\n      background: var(--var-prismer-chatbot);\n    }\n    .ant-btn-variant-outlined:not(:disabled):not(.ant-btn-disabled):hover,\n    .ant-btn-variant-dashed:not(:disabled):not(.ant-btn-disabled):hover {\n      color: var(--var-prismer-chatbot);\n      border-color: var(--var-prismer-chatbot);\n    }\n    .ant-input-outlined:hover {\n      border-color: var(--var-prismer-chatbot);\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
